import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "c-eyecatch c-eyecatch--auth-phone" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "c-eyecatch__img" })
], -1)
const _hoisted_2 = { class: "p-mypage__ttl p-mypage__ttl--complete c-ttl" }
const _hoisted_3 = { class: "p-mypage__sec" }
const _hoisted_4 = { class: "p-mypage__txt" }
const _hoisted_5 = { class: "p-mypage__btn" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "マイページに戻る", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.processMode === 'confirm' ? '認証用電話番号 登録完了' : '認証用電話番号 解除完了'), 1),
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.processMode === 'confirm' ? '認証用電話番号を登録しました。' : '認証用電話番号を解除しました。'), 1),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_router_link, {
          to: { name: 'MypageTop' },
          class: "c-btn c-btn--outline"
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}